module.exports = __webpack_public_path__ + "img/initial_consult_form.56b87c1a.png";